import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService, ToastType } from './toast.service';

const TOAST_CLASSES: Readonly<Record<ToastType, string>> = {
  success: 'text-bg-success',
  warning: 'text-bg-warning',
  error: 'text-bg-danger'
};

/**
 * Renders the notifications of the ToastService as Bootstrap toasts.
 */
@Component({
  selector: 'app-toasts',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="toast-container position-fixed top-0 end-0 p-3">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="toast show"
          [class]="toastClasses[toast.type]"
          [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
          [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
          aria-atomic="true"
          animate.enter="toast-enter"
          animate.leave="toast-leave"
        >
          <div class="d-flex">
            <div class="toast-body">
              @if (toast.title) {
                <strong class="d-block">{{ toast.title }}</strong>
              }
              {{ toast.message }}
            </div>
            <button
              type="button"
              class="btn-close me-2 m-auto"
              [class.btn-close-white]="toast.type !== 'warning'"
              aria-label="Fermer"
              (click)="toastService.dismiss(toast.id)"
            ></button>
          </div>
        </div>
      }
    </div>
  `,
  styles: `
    .toast-enter {
      animation: toast-fade-in 300ms ease-out;
    }

    .toast-leave {
      animation: toast-fade-out 300ms ease-in forwards;
    }

    @keyframes toast-fade-in {
      from {
        opacity: 0;
        transform: translateX(1rem);
      }
    }

    @keyframes toast-fade-out {
      to {
        opacity: 0;
        transform: translateX(1rem);
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .toast-enter,
      .toast-leave {
        animation: none;
      }
    }
  `
})
export class ToastsComponent {
  readonly toastService = inject(ToastService);
  readonly toastClasses = TOAST_CLASSES;
}
